import React from 'react';
import styles from './ActionMenu.module.scss';
import ActionsInLeft from './ActionsInLeft/ActionsInLeft';
import ActionsInCenter from './ActionsInCenter/ActionsInCenter';
import ActionsInRight from './ActionsInRight';

const ActionMenu = () => {
  return (
    <div className={styles.container}>
      <ActionsInLeft />
      <ActionsInCenter />
      <ActionsInRight />
    </div>
  );
};

export default ActionMenu;
